import Big from 'big.js'
import React from 'react'
import { TokenWithBalances } from 'src/common/types/models/Tokens'
// import Button from 'src/common/ui-kit/Button/Button'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import { ZERO } from 'src/common/utils/big-utils'
import {
  displayAmount,
  displayUsdAmount,
} from 'src/common/utils/formatters/number'
import './styles.css'
import Icon from 'src/common/ui-kit/Icon/Icon'
import IconButton from 'src/common/ui-kit/IconButton'
import useBreakpoint from 'src/common/hooks/ui/useBreakpoint'
import Button from 'src/common/ui-kit/Button/Button'
import { useChainFeatures } from 'src/common/hooks/web3/useChainFeatures'
import useConfig from 'src/config/hooks/useConfig'
import { areAddressesEqual } from 'src/common/utils/web3/areAddressesEqual'

interface AssetRowProps {
  asset: TokenWithBalances
  ratio: Big | null
  onTrade: () => void
  onInfo: (token: TokenWithBalances) => void
  onAddToBundle: () => void
  onWithdrawFromBundle: () => void
}

const AssetRow: React.FC<AssetRowProps> = ({
  asset,
  ratio,
  onAddToBundle,
  onWithdrawFromBundle,
  // onTrade, // Add on trade option, once params syncing on trade page will be ready
  onInfo,
}) => {
  const config = useConfig()

  const isSm = useBreakpoint('sm')
  const totalBalance = asset.balance.plus(asset.lockedAmount)
  const usdTotalBalance = totalBalance.mul(asset.exchangePrice ?? ZERO)

  const displayRatio = (ratio: Big | null) =>
    !ratio || ratio.eq(ZERO)
      ? 'N/A'
      : `${displayAmount(ratio, { maxDecimals: 2, minThreshold: 0.01 })}%`

  const displayUsdBalance = (balance?: Big) =>
    !balance || balance.eq(ZERO) ? 'N/A' : `${displayUsdAmount(balance)} USD`

  const isCarbonNft = areAddressesEqual(
    asset.contractAddress,
    config.tokensAddresses.vicc
  )

  const isCarbonERC20 = areAddressesEqual(
    asset.contractAddress,
    config.tokensAddresses.carbon
  )

  return (
    <div className='comp-asset-row comp-asset-table-row'>
      <div className='comp-asset-row-info'>
        <TokenIcon token={asset} size={isSm ? 24 : 32} />
        <div>
          <div className='comp-asset-row-token-symbol'>{asset.symbol}</div>
          <div className='comp-asset-row-token-name'>{asset.name}</div>
        </div>
      </div>

      <div className='comp-asset-row-ratio'>
        <div className='comp-asset-row-value'>{displayRatio(ratio)}</div>
      </div>

      <div className='comp-asset-row-available'>
        <div className='comp-asset-row-value'>
          {displayAmount(asset.balance)}
        </div>
        <div className='comp-asset-row-sub-value'>
          {displayUsdBalance(asset.usdBalance)}
        </div>
      </div>

      <div className='comp-asset-row-locked'>
        <div className='comp-asset-row-value'>
          {displayAmount(asset.lockedAmount)}
        </div>
        <div className='comp-asset-row-sub-value'>
          {displayUsdBalance(asset.usdLockedAmount)}
        </div>
      </div>

      <div className='comp-asset-row-amount'>
        <div className='comp-asset-row-value'>
          {displayAmount(totalBalance)}
        </div>
        <div className='comp-asset-row-sub-value'>
          {displayUsdBalance(usdTotalBalance)}
        </div>
      </div>

      <div className='comp-asset-row-actions'>
        {/* <Button className='comp-asset-row-button' onClick={onTrade}>
          Trade
        </Button> */}
        {isCarbonERC20 && (
          <Button
            size='sm'
            className='comp-asset-row-button min-w-20'
            onClick={onWithdrawFromBundle}
          >
            Withdraw NFT
          </Button>
        )}
        {isCarbonNft && (
          <Button
            size='sm'
            className='comp-asset-row-button min-w-20'
            onClick={onAddToBundle}
          >
            Add to Bundle
          </Button>
        )}
        <IconButton
          onClick={() => {
            onInfo(asset)
          }}
          className='hidden md:flex comp-asset-row-action-info text-secondary-contrast'
        >
          <Icon color='main-accent' name='info' size={20} />
        </IconButton>
      </div>
    </div>
  )
}

export default AssetRow
